import FormComponent from "./Components/FormComponent";
import React from "react";

export default class UserLiveChatMessage extends FormComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return(
            <div className={this.generateSenderClassName('user-live-chat')}>
                {this.generateSenderMessage()}
                <div className='user-live-chat__text message-text'>
                    <div className='user-live-chat__heading'>
                        {this.props.payload.heading}
                    </div>
                    <div className='user-live-chat__describtion'>
                        {this.props.payload.describtion}
                    </div>
                    <form ref={this.formRef}>
                        Iterate through form fields here.
                    </form>
                </div>
            </div>
        );
    }
}